'use client';

import styled from 'styled-components';
import { Carousel } from '@mantine/carousel';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  gap: 16px;
  width: 100%;

  z-index: 4;

  @media (max-width: 1320px) {
    max-width: 936px;
  }

  @media (max-width: 936px) {
    max-width: 618px;
  }
`;

export const UpcomingEducations = styled(Carousel)`
  width: 100%;

  .card {
    margin-right: 8px;
    padding: 24px 6px;
  }
`;
